const i18nConfig = {
  defaultLocale: 'au',
  //Update the locale au and nz
  locales: ['au', 'nz', 'uk'],
};

export default i18nConfig;